import { loadModules } from "esri-loader";
import { get, writable } from "svelte/store";
import LoadState from "../Enums/LoadState";

const initESRIMetaClass = (classPath) => {
	return {
		classPrototype: null,
		classPath: classPath
	};
};
const ESRIClassStore = {
	meta: {
		loadState: writable(LoadState.INIT)
	},
	classes: {
		Map: initESRIMetaClass("esri/Map"),
		FeatureLayer: initESRIMetaClass("esri/layers/FeatureLayer"),
		IdentityManager: initESRIMetaClass("esri/identity/IdentityManager"),
		Query: initESRIMetaClass("esri/tasks/support/Query"),
		Point: initESRIMetaClass("esri/geometry/Point"),
		SpatialReference: initESRIMetaClass("esri/geometry/SpatialReference")
	},
	helpers: {
		isLoggedIn: () => {
			return false;
		}
	},
	actions: {
		load: () => {
			// https://geollect:8080/
			// 		#access_token=123-456-789
			// 		&expires_in=7200
			// 		&username=geollect_username
			// 		&ssl=true

			return new Promise((resolve, reject) => {
				const loadState = get(ESRIClassStore.meta.loadState);
				if (loadState === LoadState.INIT) {
					ESRIClassStore.meta.loadState.set(LoadState.LOADING);

					const classKeys = Object.keys(ESRIClassStore.classes);
					const esriClasses = classKeys.map((className) => {
						return ESRIClassStore.classes[className].classPath;
					});
					loadModules(esriClasses).then((classes) => {
						for (let i = 0; i < classes.length; i++) {
							ESRIClassStore.classes[classKeys[i]].classPrototype = classes[i];
						}
						console.log("ESRIClassStore", ESRIClassStore);
						ESRIClassStore.meta.loadState.set(LoadState.LOADED);
						resolve(ESRIClassStore.classes);
					});
				}
				else if (loadState === LoadState.LOADING) {
					const unsubscribe = ESRIClassStore.meta.loadState.subscribe((loadState) => {
						if (loadState === LoadState.LOADED) {
							resolve(ESRIClassStore.classes);
							setTimeout(() => {
								unsubscribe();
							}, 1);
						}
					});
				}
				else if (loadState === LoadState.LOADED) {
					resolve(ESRIClassStore.classes);
				}
			});
		}
	}
};
export default ESRIClassStore;
